import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

/** Apre il dialog "Nuovo" della pagina quando l'URL ha ?nuovo=1 (tasto "+ Nuovo" globale), poi pulisce il parametro. */
export function useNuovoParam(apri) {
  const [sp, setSp] = useSearchParams();
  const ref = useRef(apri); ref.current = apri;
  const nuovo = sp.get("nuovo");
  useEffect(() => {
    if (!nuovo) return;
    const t = setTimeout(() => { ref.current(); const p = new URLSearchParams(sp); p.delete("nuovo"); setSp(p, { replace: true }); }, 50);
    return () => clearTimeout(t);
  }, [nuovo]); // eslint-disable-line react-hooks/exhaustive-deps
}
